import Vue from "vue";
export default {
  // GET_USER(state, payload) {
  //   state.user = payload;
  // },
  GET_Service(state, payload) {
    state.get_service = payload;
  },
  SELECTED_SERVICE_CARD(state, payload) {
    state.selected_service_card = payload;
  },
  GETALL_Service_Card(state, payload) {
    state.get_AllService = payload;
  },
  DELETE_Service(state, payload) {
    const index = state.get_AllService.result.findIndex(
      (page) => page._id === payload._id
    );
    state.get_AllService.result.splice(index, 1);
  },
  SELECT_Service(state, payload) {
    state.selectservice = payload;
  },
  DELETE_Partner(state, payload) {
    const index = state.get_AllPartner.findIndex(
      (page) => page._id === payload._id
    );
    state.get_AllPartner.splice(index, 1);
  },
  GETALL_Partner(state, payload) {
    state.get_AllPartner = payload;
  },
  SELECT_Partner(state, payload) {
    state.selectpartner = payload;
  },
  GETALL_Workshop(state, payload) {
    state.get_AllWorkshop = payload;
  },
  DELETE_Workshop(state, payload) {
    const index = state.get_AllWorkshop.findIndex(
      (page) => page._id === payload._id
    );
    state.get_AllWorkshop.splice(index, 1);
  },
  SELECT_Workshop(state, payload) {
    state.selectworkshop = payload;
  },
  GETALL_Banner(state, payload) {
    state.get_AllBanner = payload;
  },
  DELETE_Banner(state, payload) {
    const index = state.get_AllBanner.findIndex(
      (page) => page._id === payload._id
    );
    state.get_AllBanner.splice(index, 1);
  },
  SELECT_Banner(state, payload) {
    state.selectbanner = payload;
  },
  GETALL_Bannerhome(state, payload) {
    state.get_AllhomeBanner = payload;
  },
  DELETE_Bannerhome(state, payload) {
    const index = state.get_AllhomeBanner.findIndex(
      (page) => page._id === payload._id
    );
    state.get_AllhomeBanner.splice(index, 1);
  },
  SELECT_Bannerhome(state, payload) {
    state.selecthomebanner = payload;
  },
  SET_REG_FORM(state, payload) {
    state.setregform = payload;
  },
  SET_REG(state, payload) {
    state.setreg = payload;
  },

  GET_CARE_PROFS(state, payload) {
    state.getCareProfs = payload;
  },
  GET_APP_FORM(state, payload) {
    state.getAppForm = payload;
  },
  GET_DONORS(state, payload) {
    state.getDonors = payload;
  },

  GET_DONOR_TYPE(state, payload) {
    state.getDonorType = payload;
  },
};
